module.exports = __webpack_public_path__ + "img/Citi.116fb5da.svg";